// Link menu (_partials/_linkMenu.twig, in the filter bar): a <details> dropdown. Adds what <details> lacks: closes on outside
// click, Esc (returning focus to the trigger) and when another menu opens.
const menus = Array.from(document.querySelectorAll('[data-link-menu]'));

menus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
        if (menu.open) menus.forEach((other) => { if (other !== menu) other.open = false; });
    });
    menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
            menu.open = false;
            menu.querySelector('summary').focus();
        }
    });
});

if (menus.length) {
    document.addEventListener('click', (event) => {
        menus.forEach((menu) => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
    });
}
